import React, { useContext, useState, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import {
	IRestaurantPropertiesModifierGroup,
	IGetAllModifierGroupsFromCustomerByProductIdAndRestaurantId,
	IGetModifierGroupsByProductIdAndRestaurantIdArguments,
} from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getAllModifierGroupsFromCustomerByProductIdAndRestaurantId } from 'backend/modifierGroups';
import { ModifierGroups } from './ModifierGroups';

interface IProps {
	setModifierGroups: (value: string[]) => void;
	setModifierGroupsWithAdditionalData(value: IRestaurantPropertiesModifierGroup[]): void;
	productId: string;
	restaurantId: Nullable<string>;
	IDsSelectedModifierGroups: string[];
	modifierGroupsWithAdditionalData: IRestaurantPropertiesModifierGroup[];
}

export const ModifierGroupsMultipleSelect: React.FC<IProps> = ({
	setModifierGroups,
	setModifierGroupsWithAdditionalData,
	productId,
	restaurantId,
	IDsSelectedModifierGroups,
	modifierGroupsWithAdditionalData,
}) => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const [fetchedModifierGroups, setFetchedModifierGroups] = useState<IRestaurantPropertiesModifierGroup[]>([]);
	const { response, loading, refetch, responseError } = useFetchData<
		IGetAllModifierGroupsFromCustomerByProductIdAndRestaurantId,
		IGetModifierGroupsByProductIdAndRestaurantIdArguments
	>(productId && restaurantId ? getAllModifierGroupsFromCustomerByProductIdAndRestaurantId : null, {
		productId,
		restaurantId: restaurantId || '',
		type: 'Modifier',
	});

	useEffect(() => {
		productId && restaurantId && refetch();
	}, [productId, restaurantId]);

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	useEffect(() => {
		if (response) {
			setFetchedModifierGroups(response.data.modifierGroups);
		}
	}, [response]);

	return (
		<ModifierGroups
			setModifierGroups={setModifierGroups}
			setModifierGroupsWithAdditionalData={setModifierGroupsWithAdditionalData}
			refetch={refetch}
			responseError={responseError}
			IDsSelectedModifierGroups={IDsSelectedModifierGroups}
			fetchedModifierGroups={fetchedModifierGroups}
			modifierGroupsWithAdditionalData={modifierGroupsWithAdditionalData}
		/>
	);
};
